import { baseThemeValues } from 'constants/common';

const treeItemBase = {
  borderColor: 'palette.transparent',
  borderRadius: '4px',
  borderWidth: '0px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
};

export const transferTreeTheme = {
  body: {
    bg: 'palette.surface.2',
    borderColor: 'palette.transparent',
    borderRadius: '12px',
    borderWidth: '0px',
    connectLine: 'palette.surface.5',
    connectLineWidth: '2px',
    item: {
      active: {
        ...treeItemBase,
        bg: 'palette.transparent',
        text: 'palette.tertiary.95',
      },
      base: {
        ...treeItemBase,
        bg: 'palette.transparent',
        text: 'palette.tertiary.70',
      },
      connectLine: 'palette.surface.5',
      connectLineWidth: '2px',
      helperIcon: 'palette.tertiary.40',
      hover: {
        ...treeItemBase,
        bg: 'palette.surface.4',
        text: 'palette.tertiary.95',
      },
    },
  },
};
